import React, { PropsWithChildren } from 'react';

import styled from 'styled-components';

interface IFormControl {
  label: string;
  id: string;
}

const FormControl = ({
  label = '',
  id = crypto.randomUUID(),
  children,
}: PropsWithChildren<IFormControl>) => {
  return (
    <FormControlContainer>
      {label ? (
        <FormControlLabel data-role='label' htmlFor={id}>
          {label}
        </FormControlLabel>
      ) : null}
      {children}
    </FormControlContainer>
  );
};

export default FormControl;

export const FormControlContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 100%;
`;

export const FormControlLabel = styled.label`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`;
